import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import CheckIcon from '@mui/icons-material/Check';
import Grid from '@mui/material/Grid';
import {Link} from 'react-router-dom';


   const PricingCard = ({ planName, price, features, buttonText, isPopular, noPrice, getStarted }) => {

    return (
        <Card sx={{
            width: 350,
            border: isPopular ? '2px solid rgba(146, 0, 0, 0.35)' : '1px solid #e0e0e0',
            padding: isPopular ? '16px' : '8px',
            margin: '16px',
            transition: 'box-shadow 0.3s ease-in-out',
            
        }}>
            <CardContent>
                <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 1, p: 2 }}>
                    {planName}
                </Typography>
                    { planName == "MSP" ? <Typography>As little as</Typography> : <Typography>Introductory Pricing</Typography> }
                    <Typography variant="h3" component="div" sx={{ fontWeight: 'bold' }}>${price}</Typography>  
                    <Typography sx={{ typography: { xs: 'caption', md: 'caption'}}}   display="inline"> /licensed user <br /> /month</Typography> 
                <List sx={{ mt: 4}}>
                    {features.map((feature, index) => (
                        <ListItem key={index} >
                            <ListItemIcon sx={{ minWidth: '30px' }}>
                                <CheckIcon color="trawlgreen" />
                            </ListItemIcon>
                            <Typography variant="body2">{feature}</Typography>
                        </ListItem>
                    ))}
                </List>
                <Box mt={2} align="center">
                    { getStarted ?
                        <Link to="https://app.trawlai.com/sign-up" target="_blank">
                            <Button variant="contained" color="error">
                                <Typography color="grey.300">{buttonText}</Typography>
                            </Button>
                        </Link> :
                        <Link to="#contact">
                            <Button variant="contained" color="error">
                                <Typography color="grey.300">{buttonText}</Typography>
                            </Button>
                        </Link> }
                </Box>
            </CardContent>
        </Card>
    );
};

export default function PricingTable() {
    return(   
        <Box 
            width="100%"
            variant="gradient"
            sx={{
                display: "grid",
                placeItems: "center",
            }}
            mb={8}
            pb={10}
        >
            <Grid container maxWidth="lg" spacing={2}  mt={8} mb={4} p={2}>
                <Grid item xs={12} lg={8} >
                    <Typography variant="h3"  mt={8} color="grey.800" align="center">
                        Cost-Effective Microsoft 365 Security for SMBs
                    </Typography>
                    <Typography color="grey.800" align="center">PREVAIL offers RMM and PSA integration for MSPs, custom reporting and alerting, and flexible data retention options. </Typography>
                </Grid>
            </Grid>
            <Grid container maxWidth="lg" spacing={2} >
                <Grid item size={{ xs: 12, md: 4 }} >
                    <PricingCard noPrice planName="MSP" price="1" features={["Monthly or Yearly Commit",  "Unlimited Tenants", "Unlimited Admin Users", "Custom Reporting"]}  buttonText="Contact Us" />
                </Grid>
                <Grid item size={{ xs: 12, md: 4 }}>
                    <PricingCard isPopular planName="SMB" price="2" features={["One Year Data Retention", "5 Admin Users", "Two Year Metric Retention", "User Data Reporting"]} getStarted buttonText="Get Started for Free" />
                </Grid>
                <Grid item size={{ xs: 12, md: 4 }}>
                    <PricingCard  planName="Enterprise" price="5"  features={["Data retention up to 7 years", "Up to 10 admin users", "Custom Reporting", "Unlimited Tenants"]} buttonText="Contact Us"  />
                </Grid>
            </Grid>
        </Box>
    )
}